import {DataView} from "primereact/dataview";
import {Button} from "primereact/button";
import {Entry} from "../data/entry";
import {Badge} from "primereact/badge";
import {Tag} from "primereact/tag";
import {ConfirmPopup, confirmPopup} from "primereact/confirmpopup";

function EntryView({entries, onEntryDeleted}: { entries: Entry[], onEntryDeleted: (entry: Entry) => void }) {
    const confirmDelete = (target: any, entry: Entry) => {
        const accept = () => {
            onEntryDeleted(entry);
        };

        const reject = () => {
        };

        confirmPopup({
            target: target,
            message: `Are you sure that you want to delete the entry ${entry.username}?`,
            icon: "pi pi-exclamation-triangle",
            defaultFocus: "accept",
            accept,
            reject,
        });
    };

    const itemTemplate = (entry: Entry, _: number) => {
        return (
            <div
                className="flex px-2 align-items-center justify-content-between p-0 w-full transition-duration-200 gap-2">
                <ConfirmPopup/>
                <div className="w-1">
                    <Badge severity="secondary" value={entry.rank}/>
                </div>
                <div className="flex align-items-center w-6">
                    <span className="font-bold w-full text-overflow-ellipsis overflow-auto">
                        {entry.username}
                    </span>
                </div>
                <div className="flex align-items-right justify-content-end  w-4">
                    <Tag className="px-3" style={{fontSize: "1rem"}}>
                        {entry.score}
                    </Tag>
                </div>

                <div className="flex gap-2 w-1">
                    <Button
                        icon="pi pi-trash"
                        severity="danger"
                        className="p-button-rounded p-button-text"
                        tooltip="Delete Entry"
                        onClick={(event) => confirmDelete(event.currentTarget, entry)}
                    />
                </div>
            </div>
        );
    };

    const listTemplate = (entry1: Entry[]) => {
        if (!entry1 || entry1.length === 0) return (<div></div>);

        let list = entry1.map((e, index) => {
            return itemTemplate(e, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    return (
        <DataView
            paginator={true}
            rows={25}
            value={entries}
            listTemplate={listTemplate}/>
    )
}

export default EntryView;